import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Box, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { LoadingButton } from "@mui/lab";
import Stack from "@mui/material/Stack";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { API_URL } from "../utils/EnvVars";
import StarRateIcon from "@mui/icons-material/StarRate";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const labels = {
  1: "Poor",
  2: "Ok",
  3: "Good",
  4: "Very Good",
  5: "Excellent",
};

function getLabelText(value) {
  return `${value} Star${value !== 1 ? "s" : ""}, ${labels[value]}`;
}

const useStyles = makeStyles({
  paper: {
    fontSize: "12px !important",
  },
});

var vertical = "top",
  horizontal = "center";

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  var etlStudentObj = JSON.parse(localStorage.getItem("etlStudentObj"));
  var selectedCourse = localStorage.getItem("etlSelectCourse");
  var courseRating = JSON.parse(localStorage.getItem("courseRating"));
  var mySelectedCourses = JSON.parse(localStorage.getItem("etlMyCourses"));
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [remarksError, setRemarksError] = React.useState(false);
  const [remarks, setRemarks] = React.useState("");

  const [ratingValue, setRatingValue] = React.useState(3);
  const [ratingHover, setRatingHover] = React.useState(-1);

  const [averageRating, setAverageRating] = React.useState(null);
  const [reviewCount, setReviewCount] = React.useState(null);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen() {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert() {
    setShowAlert(false);
  }

  // function handleClassName(clsName){
  //   if(clsName && props.classes.length>0){
  //     for(let i=0; i<props.classes.length; i++){
  //       if(props.classes[i].className===clsName){
  //         setCourseId(props.classes[i].courseId);
  //         setCourseTitle(props.classes[i].courseTitle);
  //         setOrganisationId(props.classes[i].organisationId);
  //         setClassName(props.classes[i].className);
  //       }
  //     }
  //   }
  // }

  function saveData() {
    if (!remarks || (remarks && remarks.length < 1)) {
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("You must describe your experience");
      setRemarksError(true);
      return false;
    }

    if (remarks) {
      let axiosHeader = {
        headers: {
          "Content-Type": "multipart/mixed",
          loginId: etlStudentObj.loginId,
          token: etlStudentObj.token,
          device: "web",
        },
      };

      const data = new FormData();
      data.append("courseId", mySelectedCourses[selectedCourse].courseId);
      data.append(
        "courseName",
        mySelectedCourses[selectedCourse].organisationName
      );
      data.append("rating", ratingValue);
      data.append("remarks", remarks);

      setSaveLoading(true);
      axios
        .post(API_URL + "/rating-create", data, axiosHeader)
        .then((response) => {
          setSaveLoading(false);
          ///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
          if (response.data.responseTxt === "success") {
            setSeverityAlert("success");
            setOpen(false);
            setShowAlert(true);
            setAlertMessage("Thanks for sharing your experience with us");
            return false;
          } else if (response.data.responseTxt === "given") {
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage(
              "You have already submitted your experience with us for this course."
            );
            return false;
          } else if (response.data.responseTxt === "invalidToken") {
            window.localStorage.clear();
            window.location.href = "logout";
          } else {
            setSeverityAlert("error");
            setShowAlert(true);
            setAlertMessage("It could not be saved.");
            return false;
          }
        })
        .catch((error) => {
          ///console.log("AXIOS ERROR: ", error);
        });
    }
  }

  React.useEffect(() => {
    setRemarks("");
    if (courseRating) {
      setReviewCount(courseRating?.reviewsCount);
      setAverageRating(courseRating?.averageRating);
    }
  }, [open]);

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          style={{ marginBottom: "-30px" }}
          onClose={handleClose}
        ></DialogTitle>
        <DialogContent style={{ height: 250 }}>
          <Grid item md={12} xs={12} className="test-instructions">
            <div
              className="btmbdrgry"
              style={{
                display: "flex",
                gap: 8,
                alignItems: "center",
                lineHeight: 2,
                paddingBottom: 8
              }}
            >
              <h3>
                Write your experience about:{" "}
                {mySelectedCourses && mySelectedCourses[selectedCourse]
                  ? mySelectedCourses[selectedCourse].organisationName
                  : null}
              </h3>
              <div
                style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                <div style={{border: '1px solid #555', borderRadius: '5000px', display: 'flex', gap: 4, padding: '4px 8px', alignItems: 'center'}}>
                  <StarRateIcon fontSize="small" style={{fill: "orange", color: "orange"}} />
                  <p style={{padding: 0, fontWeight: '600'}}>{averageRating}</p>
                  <p style={{padding: 0, fontWeight: '600'}}>{`(${reviewCount})`}</p>
                </div>
              </div>
            </div>
            <p>
              <Box
                sx={{
                  width: "200",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Rating
                  name="hover-feedback"
                  value={ratingValue}
                  getLabelText={getLabelText}
                  onChange={(event, newValue) => {
                    setRatingValue(newValue);
                  }}
                  onChangeActive={(event, newHover) => {
                    setRatingHover(newHover);
                  }}
                  emptyIcon={
                    <StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />
                  }
                />
                {ratingValue !== null && (
                  <Box sx={{ ml: 2 }}>
                    {labels[ratingHover !== -1 ? ratingHover : ratingValue]}
                  </Box>
                )}
              </Box>

              <TextField
                placeholder="Describe your experience"
                onChange={(event) => setRemarks(event.target.value)}
                value={remarks}
                sx={{ width: "99%", fontSize: 10 }}
                variant="outlined"
                error={remarksError}
                multiline
              />

              <Box mt={2}>
                <Button
                  onClick={() => {
                    handleClose();
                  }}
                  style={{ marginRight: 12 }}
                  size="small"
                  variant="outlined"
                >
                  Cancel
                </Button>

                {saveLoading ? (
                  <LoadingButton
                    loading={saveLoading}
                    loadingPosition="start"
                    startIcon={<div style={{ marginRight: 15 }}></div>}
                    style={{
                      backgroundColor: "#ffa500",
                      color: "#000",
                      marginLeft: 10,
                    }}
                    size="small"
                    variant="contained"
                  >
                    Wait...
                  </LoadingButton>
                ) : (
                  <Button
                    onClick={() => {
                      saveData();
                    }}
                    style={{
                      backgroundColor: "#008000",
                      color: "#FFF",
                      marginLeft: 10,
                    }}
                    size="small"
                    variant="contained"
                  >
                    Save
                  </Button>
                )}
              </Box>
            </p>
          </Grid>
        </DialogContent>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={showAlert}
          autoHideDuration={6000}
          onClose={hideAlert}
          anchorOrigin={{ vertical, horizontal }}
        >
          <Alert
            onClose={hideAlert}
            variant="filled"
            severity={severityAlert}
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
});

export default CustomizedDialogs;
